import {
  ESimulatorAMS275912SteelClass,
} from '@/types/simulator.ts';

const details: Record<ESimulatorAMS275912SteelClass, string> = {
  [ESimulatorAMS275912SteelClass.GROUP_0]: 'HLSA, obyčajný uhlík – 5,1 do 25 µm',
  [ESimulatorAMS275912SteelClass.GROUP_1]: '4140, 4340, Nitralloy 135 – nízkolegované ocele 5,1 do 25, nástrojové ocele 2,5 do 15',
  [ESimulatorAMS275912SteelClass.GROUP_2]: 'Liatina – 5,1 do 25 µm',
};

export default {
  details,
};
